import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Snackbar } from '@mui/material';
import { Formik } from 'formik';

import Alert from 'src/components/Alert';
import { CONSTANTS, STRINGS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { addGym } from 'src/api/batches';
import GymForm from 'src/components/gymForm';

const AddGymModal = ({ handleCloseModal, getData }) => {
  const { startLoading, stopLoading } = loaderReducerAction;
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.common);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Container
        maxWidth="sm"
        sx={{
          padding: '.8rem',
          backgroundColor: 'background.default',
          borderRadius: '10px'
        }}
      >
        <Formik
          initialValues={{
            name: '',
            phone: null,
            email: '',
            address: ''
          }}
          validationSchema={CONSTANTS.gymValidationSchema}
          onSubmit={async (values) => {
            const formData = new FormData();
            formData.append('name', values.name);
            formData.append('email', values.email);
            formData.append('phone', values.phone);
            formData.append('address', values.address);
            formData.append('calling_code', values.callingCode);
            formData.append('currency', values.currency);
            if (values.logo) {
              formData.append('logo', values.logo);
            }
            try {
              dispatch(startLoading());
              const res = await addGym(user, formData);
              dispatch(stopLoading());
              const isError = res.status !== 200;
              const message = isError ? res?.message : 'Gym Added Successfully';
              setSnackbarState({
                open: true,
                message: message,
                severity: isError ? 'error' : 'success'
              });
              if (!isError) {
                handleCloseModal();
                getData();
              }
            } catch (err) {
              dispatch(stopLoading());
              setSnackbarState({
                open: true,
                message: err.message,
                severity: 'error'
              });
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            touched,
            values
          }) => (
            <GymForm
              errors={errors}
              handleBlur={handleBlur}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              setFieldValue={setFieldValue}
              isSubmitting={isSubmitting}
              touched={touched}
              values={values}
              handleCloseModal={handleCloseModal}
              heading={STRINGS.ADD_GYM}
            />
          )}
        </Formik>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={snackbarState.open}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <div>
            <Alert onClose={handleClose} severity={snackbarState.severity}>
              {snackbarState.message}
            </Alert>
          </div>
        </Snackbar>
      </Container>
    </>
  );
};

export default AddGymModal;
